<template lang="html">

  <article class="col-33">
    <div class="flex row justify-between">
      <a class="user" href="https://twitter.com/Ajusa_Spain" target="_blank">@Ajusa_spain</a>
      <span class="date"></span>
    </div>
    <p class="texto">
      <a target="_blank" class="enlace-cover" v-if="!!data.entities.urls.length > 0" :href="data.entities.urls[0].url"></a>
      {{data.text}}
    </p>
    <div class="flex row justify-between">
      <a class="go" target="_blank" :href="`http://twitter.com/${data.user.screen_name}/status/${data.id_str}`">{{$t('actualidad.twitter.acceder')}}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
      <a class="fa-brands fa-x-twitter" href="https://twitter.com/ajusa_spain?lang=es" target="_blank"></a>
    </div>
  </article>

</template>

<script lang="js">
  export default  {
    name: 'tweet-el',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
.texto{
  position: relative;
}

.texto .enlace-cover{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/tweet-el.vue